import { ReducerFunctions } from "../../utils";
import {
  Employees,
  AddEmployees,
  DeleteEmployees,
  EmployeesStatus,
  UpdateEmployees,
  UploadBulk,
  GetUserFields,
  DownloadBulkLink,
  GetUsersList,
  GetProfile,
} from "./employees";

export const upload_bulk_employees_reducer = ReducerFunctions(UploadBulk, {});
export const download_link_reducer = ReducerFunctions(DownloadBulkLink, {});
export const get_user_fields_reducer = ReducerFunctions(GetUserFields, {});
export const employees_reducer = ReducerFunctions(Employees, {});
export const employees_status_reducer = ReducerFunctions(EmployeesStatus, {});
export const add_employees_reducer = ReducerFunctions(AddEmployees, {});
export const update_employees_reducer = ReducerFunctions(UpdateEmployees, {});
export const delete_employees_reducer = ReducerFunctions(DeleteEmployees, {});
export const users_list_reducer = ReducerFunctions(GetUsersList, {});
export const profile_reducer = ReducerFunctions(GetProfile, {});
